const paymentsStates = [
  {
    class: '',
    id: '',
    name: 'Todos los estados'
  },

  {
    class: 'text-color-warning',
    id: 4,
    name: 'Anulado'
  },

  {
    class: 'text-color-danger',
    id: 5,
    name: 'Cancelado'
  },

  {
    class: 'text-color-info',
    id: 1,
    name: 'Confirmado'
  },

  {
    class: 'text-color-success',
    id: 2,
    name: 'Pagado'
  },

  {
    class: 'text-color-info',
    id: 0,
    name: 'En Proceso'
  },

  {
    class: 'text-color-products-primary',
    id: 3,
    name: 'Reembolsado'
  }
]

export default paymentsStates
